var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!this.$store.getters.iframeColidee)?_c('Header',{attrs:{"window":_vm.window,"parameters":'adminLinks'}}):_vm._e(),_vm._v(" "),_c('LinkList'),_vm._v(" "),(!this.$store.getters.iframeColidee)?_c('Footer',{attrs:{"window":_vm.window}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dba0eeb","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/AdminLinks.vue
// module id = null
// module chunks = 